<template>
  <div :class="[baseCss, position, visible ? null : ['opacity-0', 'pointer-events-none'], 'inline-block', 'text-center', 'select-none', 'transition-all', 'duration-300', `rounded-${rounded}`]" :style="{backdropFilter: `blur(${backdropBlur})`, zIndex, background: bgColor}">
    <icon :class="['block']" :name="name" :icon-provider="iconProvider" :size="size" :style="{color}" />
    <div v-if="$slots.default">
      <slot />
    </div>
  </div>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'VisualFeedbackIcon',
  mixins: [
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('visual-feedback-icon', [])
    }
  },
  props: {
    name: {
      type: String,
      default: 'emoticon'
    },
    iconProvider: {
      type: String,
      default: 'mdi'
    },
    size: {
      type: Number,
      default: 6
    },
    visible: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: 'rgba(128, 128, 128, 1)'
    },
    bgColor: {
      type: String,
      default: 'rgba(0, 0, 0, .25)'
    },
    rounded: {
      type: String,
      default: '2xl',
      validator: value => {
        return ['none', 'sm', 'md', 'lg', 'xl', '2xl', '3xl', 'full'].includes(value)
      }
    },
    backdropBlur: {
      type: String,
      default: '20px'
    },
    position: {
      type: String,
      default: 'fixed',
      validator: value => {
        return ['fixed', 'static', 'relative', 'absolute', 'sticky'].includes(value)
      }
    },
    zIndex: {
      type: Number,
      default: 1000
    }
  }
}
</script>
<style>
.bcq-visual-feedback-icon.fixed,
.bcq-visual-feedback-icon.absolute
{
  top: 50%;
  left: 50%;
  transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/visual-feedback-icon/visual-feedback-icon.vue